
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    IcoEndoso: () => import("@/views/client/dashboard/icons/IcoEndoso.vue"),
    IcoEndosoMov: () =>
      import("@/views/client/dashboard/icons/IcoEndosoMov.vue"),
    IcoSiniestro: () =>
      import("@/views/client/dashboard/icons/IcoSiniestro.vue"),
    IcoSolicitud: () =>
      import("@/views/client/dashboard/icons/IcoSolicitud.vue")
  }
})
export default class Icon extends Vue {
  @Prop(String) readonly selectedIcon: string;
  @Prop(String) readonly width: string;
  @Prop(String) readonly height: string;
}
